import useLogger from '@/composables/useLogger'

const LoggerPlugin = {
  install (Vue) {
    Vue.prototype.$logger = useLogger('r4')
  }
}

export default LoggerPlugin

// Vue 3
// export default {
//   install: (app, options) => {
//     consola.level = (options || {}).level || 5

//     // make all console.log go to consola
//     consola.wrapConsole()

//     app.config.globalProperties.$logger = consola
//   }
// }
